import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import find from 'lodash/find'
import Spinner from '@components/spinner'
import NoContent from '@components/Error/NoContent'
import Pagination from '@components/Pagination/Pagination'
import Action from '@components/Action'
import DownloadIcon from '@components/Icon/Download'
import { tokenStorage, formatDate } from '@atheneum/api/dist/lib'
import PropTypes from 'prop-types'

import { StatusLabel } from '@components/StatusLabel'

class Fees extends Component {
  constructor (props) {
    super(props)
    props.contractStore.getFees()
  }

  onExportClick = () => {
    const { contract } = this.props.contractStore
    const token = tokenStorage.get()
    const url = `/api/fee/contract/${contract.id}?excel=true&token=${token}`
    window.open(url)
  }

  render () {
    const {
      contract,
      fees,
      feeCount,
      getFees,
      feesLoading,
      feesPage
    } = this.props.contractStore
    const { staticData } = this.props

    if (feeCount === 0) return <NoContent />
    if (feesLoading) return <Spinner />

    return (
      <div>
        <div className='actions-wrapper actions-wrapper--space-between'>
          <ul className='actions'>
            <li>
              <Action onClick={this.onExportClick}>
                <DownloadIcon />
                <span>Export</span>
              </Action>
            </li>
          </ul>
        </div>
        <table className='table-wrapper invoice-table'>
          <thead>
            <tr className='title'>
              <th>Project name</th>
              <th>Status</th>
              <th>Case code</th>
              <th>Office</th>
              <th>Contact</th>
              <th>Delivery date</th>
              <th>Delivered service</th>
              <th className='right-align'>Fee</th>
              <th className='right-align'>Amount</th>
            </tr>
          </thead>
          <tbody>
            {fees.map(fee => (
              <FeeRow
                key={fee.id}
                fee={fee}
                contract={contract}
                staticData={staticData}
                sidebarStore={this.props.sidebarStore}
              />
            ))}
          </tbody>
        </table>
        <Pagination
          total={feeCount}
          perPage={10}
          page={feesPage}
          onChange={p => getFees(p)}
        />
      </div>
    )
  }

  static propTypes = {
    contractStore: PropTypes.object,
    sidebarStore: PropTypes.object,
    staticData: PropTypes.object
  }
}

function FeeRow ({ fee, contract, staticData, sidebarStore }) {
  const { project } = fee

  return (
    <tr>
      <td>
        <span
          className='row--link'
          onClick={() => {
            sidebarStore.openSidebar({
              id: project.id,
              template: 'project'
            })
          }}
        >
          {project.projectName}
        </span>
      </td>
      <td>
        <StatusLabel
          statusId={project.projectStatusId}
          statusesType='projectStatuses'
        />
      </td>
      <td>{project.caseCode}</td>
      <td>
        <span
          className='row--link'
          onClick={() => {
            sidebarStore.openSidebar({
              id: project.officeId,
              template: 'client-office'
            })
          }}
        >
          {project.office.officeName}
        </span>
      </td>
      <td>
        <span
          className='row--link'
          onClick={() => {
            sidebarStore.openSidebar({
              id: project.clients[0].id,
              template: 'client-contact'
            })
          }}
        >
          {project.clients[0].title} {project.clients[0].fullName}
        </span>
      </td>
      <td>{formatDate(fee.deliveryDate)}</td>
      <td>{fee.deliverable.name}</td>
      <td className='right-align'>
        {valueOrCredits(fee, contract, staticData)}
      </td>
      <td className='right-align'>{showFormattedFeeAmount(fee, staticData)}</td>
    </tr>
  )
}

FeeRow.propTypes = {
  fee: PropTypes.object,
  contract: PropTypes.object,
  staticData: PropTypes.object,
  sidebarStore: PropTypes.object
}

function valueOrCredits (fee, contract, staticData) {
  const { currencies } = staticData.names
  const { CONTRACT_TYPES } = staticData.CONST
  const feeItem = find(fee.feeItems, item => item.feeTypeId)

  if (contract.contractTypeId === CONTRACT_TYPES.PAYG) {
    return `${feeItem.value} ${currencies[feeItem.currencyId]}`
  }

  return feeItem.credits ? `${feeItem.credits} credits` : '-'
}

function showFormattedFeeAmount (fee, staticData) {
  const { feeItems } = fee
  const { currencies } = staticData.names
  if (!feeItems || !feeItems.length) return '-'

  const feeItem = find(feeItems, item => item.feeTypeId)
  if (!feeItem) return '-'

  const amount = feeItem.value
  const currencyId = feeItem.currencyId
  if (typeof amount !== 'number' || !currencyId) return '-'

  return `${amount} ${currencies[currencyId]}`
}

export default inject('staticData', 'sidebarStore')(observer(Fees))
